import { withZod } from '@remix-validated-form/with-zod'
import { z } from 'zod'

export const extractionHintsSchema = z.object({
  callId: z.string().min(1),
  patientName: z.string().min(1),
  patientBirthdate: z.string().min(1),
  treatment: z.string().min(1),
  appointmentDate: z.string().min(1),
  callerPhone: z.string().min(1),
  staff: z.string().min(1),
  callOutcome: z.string().min(1),
  referral: z.string().min(1),
  newPatient: z.string().min(1),
  insuranceProvider: z.string().min(1),
  patientScheduled: z.string().min(1),
  appointmentTime: z.string().min(1),
  summary: z.string().min(1),
})

export const extractionHintsValidator = withZod(extractionHintsSchema)
